import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';

import { GlobalContext } from '../../context/GlobalContext';
import { OTP, Typography } from 'mobily-ui-library/lib';

import './FTTHOTP.scss';
import HeaderNavigation from '../../components/HeaderNavigation/HeaderNavigation';
import { resendOtp, validateAuth } from '../../api/api';
import { setupFeeLead } from '../../api/apigeeApi';

const win: any = window;

interface Props {
    handleHeaderCancel: () => void;
}

function FTTHOTP({ handleHeaderCancel }: Props) {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, msisdn, refId, formData } = state;
    const { t } = useTranslation();

    const [timer, setTimer] = useState(120);
    const [attempt, setAttempt] = useState(0);
    const [otpValue, setotpValue] = useState('');
    const [showOTPError, setShowOTPError] = useState(false);

    useEffect(() => {
        dispatch({ type: 'SET_LOADER', payload: false });
        let countdown: any;
        const countdownFunction = () => {
            countdown = setInterval(() => {
                setTimer(prevTimer => {
                    if (prevTimer > 0) {
                        return prevTimer - 1;
                    } else {
                        clearInterval(countdown);
                        return 0;
                    }
                });
            }, 1000);
        }
        countdownFunction();

        return () => clearInterval(countdown);
    }, [timer, dispatch]);

    const formatTime = (time: any) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };


    const handleOTPChange = (otp: any) => {
        setotpValue(otp);

        if (otp.length === 4) {
            dispatch({ type: "SET_LOADER", payload: true });
            validateOTPAPI(otp);
        }
    }

    const validateOTPAPI = (otp: any) => {
        const data = {
            "operation": "VALIDATE_OTP",
            "extraInfo": [
              {
                "key": "REF_ID",
                "value": refId
              },
              {
                "key": "OTP",
                "value": otp
              }
            ]
        };
        validateAuth(data).then(async (res: any) => {
            setotpValue("");
            if (res.status === 204) {
              const response = await setupFeeLead(formData);
              if (response.status === 200) {
                dispatch({ type: "UPDATE_PAGE", payload: 'success' });
                dispatch({ type: "UPDATE_LEAD_REQUESTID", payload: response?.data?.LeadRequestId });
                dispatch({ type: "SET_LOADER", payload: false });
              } else {
                console.log('')
                dispatch({ type: "UPDATE_PAGE", payload: 'error' });
                dispatch({ type: "SET_LOADER", payload: false });
              }
            } else {
              dispatch({ type: "SET_LOADER", payload: false });
              setShowOTPError(true)
            
            }
        }).catch(() => {
            dispatch({ type: "SET_LOADER", payload: false });
            if (!!win["errorPageURL"]) {
                document.location.href = win["errorPageURL"];
            }
        })
        setotpValue("");
    }

    const handleResend = () => {
        setTimer(120);
        setAttempt(prev => prev + 1);
        dispatch({ type: "SET_LOADER", payload: true });
        const data = {
            "operation": "RESEND_OTP",
            "extraInfo": [
              {
                "key": "REF_ID",
                "value": refId
              }
            ]
        }

        resendOtp(data).then((res: any) => {
            dispatch({ type: "SET_LOADER", payload: false });
            if (res.status === 200) {
                setotpValue("");
            }
        });
    }

    const handleBackArrow = () => {

    }

    return (
        <div className='FTTH__OTPContainer'>
            <HeaderNavigation
                rtl={rtl}
                percent={100}
                showBackArrow={true}
                handleBackArrow={handleBackArrow}
                handleHeaderCancel={handleHeaderCancel}
            />
            <div className='SL__headerText'>
                <Typography rtl={rtl} id="verify-heading" className='SL__heading'>{t('Verify_heading')}</Typography>
                <Typography rtl={rtl} id="verify-Subheading" className='SL__subHeading'>
                    {t('Verify_Subheading')}
                    <div className='Verify__Msisdn'>{msisdn}.</div>
                    <div>{t('Verify_ToContinue')}</div>
                </Typography>
            </div>

            <div className='Verify__OTP'>
                <OTP id="otp-input" rtl={rtl} numInputs={4} onChange={handleOTPChange} value={otpValue} />
                {showOTPError && (
                    <Typography className='Verify__otpError' rtl={rtl}>
                        {t("code_not_valid")}
                        {/* <span id='resend-otp' className='Verify__sendAgain_error' onClick={handleResend}>
                            {t("Send_again")}
                        </span> */}
                    </Typography>)}
                {attempt < 4 && (timer > 0 ? (
                    <Typography id="resend-code" rtl={rtl} className='Verify__timer'>
                        {t('Verify_ResendNewCode')} <span>{formatTime(timer)}</span>
                    </Typography>
                ) : (
                    <Typography className='Verify__Resend' rtl={rtl}>
                        {t("Didnt_receive_the_code")}
                        <span id='resend-otp' className='Verify__sendAgain' onClick={handleResend}>
                            {t("Send_again")}
                        </span>
                    </Typography>
                ))}
            </div>
        </div>
    )
}

export default FTTHOTP